const normalizePresetPayload = (payload) => {
  const source = payload || {};
  const items = Array.isArray(source.items)
    ? source.items
    : Array.isArray(source.all)
      ? source.all
      : Array.isArray(source)
        ? source
        : [];

  const ownerType = source.ownerType || (source.ownerId ? 'university' : 'virtual-medic');
  const ownerId = source.ownerId ?? null;

  return {
    items: items.map((item) => ({
      ...item,
      ownerType: item.ownerType || ownerType,
      ownerId: item.ownerId ?? ownerId
    })),
    ownerType,
    ownerId
  };
};

export const loadCaseEditorPresets = async ({ apiClient, includeGroups }) => {
  const groupsRequest = includeGroups
    ? apiClient.get('/groups')
      .then((response) => ({
        data: Array.isArray(response.data) ? response.data : [],
        error: null
      }))
      .catch((error) => ({ data: [], error }))
    : Promise.resolve({ data: [], error: null });

  const [complaintsRes, specialtiesRes, charactersRes, voicesRes, geminiVoicesRes, groupsResult] = await Promise.all([
    apiClient.get('/platform/presets/presenting-complaints'),
    apiClient.get('/platform/presets/specialties'),
    apiClient.get('/platform/characters'),
    apiClient.get('/platform/voices'),
    apiClient.get('/platform/voices/gemini'),
    groupsRequest
  ]);

  const complaintPayload = normalizePresetPayload(complaintsRes.data);
  const specialtyPayload = normalizePresetPayload(specialtiesRes.data);

  return {
    presets: {
      presentingComplaints: complaintPayload.items,
      presentingComplaintGroups: complaintPayload,
      specialties: specialtyPayload.items,
      specialtyGroups: specialtyPayload,
      characters: Array.isArray(charactersRes.data) ? charactersRes.data : [],
      voiceModels: Array.isArray(voicesRes.data) ? voicesRes.data : [],
      geminiVoiceModels: Array.isArray(geminiVoicesRes.data) ? geminiVoicesRes.data : [],
      groups: groupsResult.data
    },
    groupsError: groupsResult.error
  };
};
